import React, { useState, useRef } from "react";
import "../css/chapterLeadership.css";

export default function ChapterLeadership() {
  const [showForm, setShowForm] = useState(false);
  const formRef = useRef(null); // Reference to the form section

  const handleApplyClick = () => {
    setShowForm(true);

    // Small timeout ensures the 'visible' class is applied
    // and height is calculated before scrolling
    setTimeout(() => {
      formRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 100);
  };

  return (
    <div className="container-fluid chapter-section">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12 col-lg-11">
            <div className="chapter-content">
              {/* Title and Subtitle */}
              <h2 className="chapter-subtitle mb-2">
                Start a GITA Chapter at Your City
              </h2>
              <h1 className="chapter-title mb-4">Lead Change. Build Impact.</h1>

              {/* Body text */}
              <div className="chapter-body-text">
                <p>
                  GITA (Global Institution for Transformative Actions) is a
                  youth-led impact ecosystem working across sustainability,
                  women empowerment, and social responsibility and we're looking
                  for passionate young leaders like you.
                </p>

                <p className="mb-3 fw-bold text-dark fs-5">
                  As a Chapter Leader, you will:
                </p>

                {/* THE UPGRADE: Custom Icon Feature List */}
                <ul className="list-unstyled mb-4 chapter-feature-list">
                  <li className="d-flex align-items-center mb-3">
                    <div className="feature-icon">
                      <i className="fas fa-map-marker-alt"></i>
                    </div>
                    <span className="fw-medium text-dark">
                      Lead on-ground initiatives at your college
                    </span>
                  </li>
                  <li className="d-flex align-items-center mb-3">
                    <div className="feature-icon">
                      <i className="fas fa-users"></i>
                    </div>
                    <span className="fw-medium text-dark">
                      Build and mentor your own team
                    </span>
                  </li>
                  <li className="d-flex align-items-center mb-3">
                    <div className="feature-icon">
                      <i className="fas fa-hands-helping"></i>
                    </div>
                    <span className="fw-medium text-dark">
                      Contribute to impactful projects across GITA's focus areas
                    </span>
                  </li>
                  <li className="d-flex align-items-center mb-3">
                    <div className="feature-icon">
                      <i className="fas fa-rocket"></i>
                    </div>
                    <span className="fw-medium text-dark">
                      Receive mentorship, resources, and a powerful platform to
                      grow
                    </span>
                  </li>
                </ul>

                <p>
                  With 1,000+ individuals reached and active chapters across
                  Delhi NCR, GITA is a growing network of changemakers and your
                  city could be next.
                </p>

                <p className="chapter-highlight mt-4 mb-2">
                  This is your opportunity to step up, lead, and make a real
                  difference. Applications are open. Don't miss out!
                </p>

                {/* Fixed the broken className syntax here! */}
                <p className="text-muted" style={{ fontSize: "0.95rem" }}>
                  For any queries, please contact us at{" "}
                  <a href="mailto:info@gita-global.in" className="text-muted">
                    info@gita-global.in
                  </a>
                  .
                </p>
              </div>

              <div className="chapter-contact-footer mt-4">
                <div className="d-flex flex-wrap gap-3">
                  {!showForm && (
                    <button className="chapter-btn" onClick={handleApplyClick}>
                      Apply Now <i className="fas fa-chevron-down ms-2"></i>
                    </button>
                  )}
                </div>
              </div>
            </div>

            {/* The hidden form section that rolls down */}
            <div
              ref={formRef}
              className={`form-roll-down ${showForm ? "visible" : ""}`}
            >
              <div className="card shadow-lg border-0 rounded-4 overflow-hidden bg-white mt-4">
                <iframe
                  src="https://docs.google.com/forms/d/e/1FAIpQLSf4SECe2_RARsKr1h6iJbW3aSne3N9iLxqeKAoHZVbJKZelPg/viewform?embedded=true"
                  width="100%"
                  height="1500"
                  frameBorder="0"
                  marginHeight="0"
                  marginWidth="0"
                  title="Chapter Leadership Form"
                >
                  Loading…
                </iframe>
              </div>

              {showForm && (
                <div className="text-center mt-4 mb-5">
                  <button
                    className="btn btn-link text-muted text-decoration-none"
                    onClick={() => setShowForm(false)}
                  >
                    <i className="fas fa-chevron-up me-2"></i> Close Form
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
